import adfox from '../../di/adfox';

export default function initAdFox() {
  window.adfoxService = adfox;
}



// WEBPACK FOOTER //
// ./src/bundles/adfox/index.ts